import ApiService from '../../../../services/ApiService'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive'
import CustomizeQRCode from './components/customizeQrCode.vue'
import SubDepartmentTab from './subdepartment/subdepartment.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    InstitutionInactive,
    CustomizeQRCode,
    SubDepartmentTab,
    draggable,
  },

  data: () => ({
    activeTab: 0,
    userId: null,
    editLoading: false,
    currentSubDepartment: {},
    editSubdepartmentKey: false,
    editSubdepartmentDialog: false,
    addDialog: false,
    active: true,
    unidades: [],
    unidadeId: null,
    isEditing: false,
    applyRules: true,
    alterDialog: false,
    changedData: false,
    confirmDialog: false,
    deleteDialog: false,
    loading: false,
    departmentLoading: false,
    deleteLoading: false,
    showSuccess: false,
    error: false,
    status: true,
    institutionInactive: false,
    errorMessage: '',
    message: '',
    institutionId: null,
    departmentId: 0,
    departments: [],
    departmentName: null,
    alphabeticalOrder: false,
    currentDepartment: {
      unidadeId: null,
      id: 0,
      name: '',
      initials: '',
      subDepartments: [],
      status: 0,
      costCenter: {
        id: 0,
        name: '',
        initials: '',
      },
    },

    deletedDepartment: null,
    file: null,
    apiService: new ApiService(),
    newDepartment: {
      id: null,
      Name: null,
      initials: null,
      unidadeId: null,
      subDepartments: [],
      status: 0,
      plannedOpex: null,
    },

    opexYear: new Date().getFullYear(),

    page: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalPages: 1,
    totalItems: 0,

    customizeDialog: false,
    showFilters: false,
    exportMenu: [
      {
        icon: 'mdi-microsoft-excel',
        title: 'Excel',
        action: 'excel',
        access: [0, 1, 2, 3],
      },
      {
        icon: 'mdi-qrcode',
        title: 'QRCode',
        options: [
          {
            title: 'Customizar QRCODE',
            action: 'qrcode-customize',
            icon: 'mdi-circle-edit-outline',
          },

          {
            title: 'QRCode Etiqueta',
            action: 'qrcode',
            icon: 'mdi-ticket',
          },

          {
            title: 'QRCode Excel',
            action: 'qrcodeXlsx',
            icon: 'mdi-microsoft-excel',
          },
        ],
        access: [0, 1, 2, 3],
      },
    ],
  }),

  computed: {
    displayedDepartments: {
      get() {
        if (this.alphabeticalOrder) {
          return [...this.departments].sort((a, b) =>
            a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
          )
        } else {
          return [...this.departments].sort((a, b) => {
            if (a.displayOrder != null && b.displayOrder != null) {
              return a.displayOrder - b.displayOrder
            }
            if (a.displayOrder != null) return -1
            if (b.displayOrder != null) return 1
            return a.id - b.id
          })
        }
      },
      set(value) {
        if (!this.alphabeticalOrder) {
          this.departments = value
        }
      },
    },

    buttonText() {
      if (this.isEditing) {
        return 'Atualizar'
      } else {
        return 'Adicionar'
      }
    },
  },

  async created() {
    const institution = JSON.parse(localStorage.getItem('institution'))
    const user = JSON.parse(localStorage.getItem('user'))

    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1

    this.userId = user.id

    this.searchDepartment()
    this.getUnidades()
  },

  methods: {
    toggleAlphabeticalOrder() {},

    onDragEnd() {
      this.saveOrderToDatabase()
    },

    saveOrderToDatabase() {
      this.loading = true

      const orderedIds = this.departments.map((department, index) => ({
        id: department.id,
        displayOrder: index,
      }))

      this.apiService
        .put('department/update-order', { departments: orderedIds })
        .then(() => {
          this.$toast.success('Ordem atualizada com sucesso!')
          this.loading = false
          this.searchDepartment()
        })
        .catch((error) => {
          this.loading = false
          this.$toast.error('Erro ao atualizar a ordem dos setores.')
          console.error('Erro ao salvar ordem:', error)
          this.searchDepartment()
        })
    },

    openEdit(subDepartment) {
      this.currentSubDepartment = subDepartment
      this.editSubdepartmentKey = !this.editSubdepartmentKey
      this.editSubdepartmentDialog = true
    },

    menuExportActionClick(action) {
      switch (action) {
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
        case 'excel':
          this.searchDepartmentExcel()
          break
      }
    },

    menuChildExport(action) {
      switch (action) {
        case 'qrcode-customize':
          this.openCustomizeQR()
          break
        case 'qrcode':
          this.openExportQrCode()
          break
        case 'qrcodeXlsx':
          this.gerenarateQrCodeExcel()
          break
      }
    },

    openCustomizeQR() {
      this.customizeDialog = true
    },

    async gerenarateQrCodeExcel() {
      const filter = {
        departmentName: this.departmentName,
        active: this.active,
        unityId: this.unidadeId,
        baseUrl: window.location.origin + '/newCalled',
        institutionId: this.institutionId,
      }

      this.printDialog = true
      const fileName = `QrCodeList.xlsx`

      await this.apiService
        .post('department/get-qrcodes/excel', filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
    },

    openExportQrCode() {
      const filter = {
        departmentName: this.departmentName,
        active: this.active,
        unityId: this.unidadeId,
        institutionId: this.institutionId,
      }
      this.filter = sessionStorage.setItem(
        'departmentFilters',
        JSON.stringify(filter)
      )

      this.$router.push({
        name: 'sectorExportQrcode',
        params: { filter: filter },
      })
    },

    addDepartmentDialog() {
      this.newDepartment = {
        Name: null,
        initials: null,
        unidadeId: null,
        subDepartments: [],
        plannedOpex: null,
      }
      this.addDialog = true
    },

    editDepartment(i) {
      this.isEditing = true
      this.institutionId, (this.newDepartment.id = i.id)
      this.newDepartment.unidadeId = i.unidadeId
      this.newDepartment.name = i.name
      this.newDepartment.initials = i.initials
      this.newDepartment.subDepartments = JSON.parse(
        JSON.stringify(i.subDepartments)
      )
      this.newDepartment.status = i.status
      this.newDepartment.plannedOpex = this.getPlannedOpex(i, this.opexYear)
      this.addDialog = true
    },

    getPlannedOpex(department, year) {
      const budget = (department.opexBudgets || []).find(
        (x) => x.year === year
      )
      return budget ? budget.plannedOpex : null
    },

    handleSubdepAction({ type, payload }) {
      this.loading = true
      if (type === 'add') {
        this.apiService
          .post('department/subdepartment/add', payload)
          .then((response) => {
            this.$toast.success(this.$t('Sub-setor adicionado com sucesso'))
            const created = response.content
            if (created && created.id) {
              this.newDepartment.subDepartments.push(created)
            }
            this.searchDepartment()
          })
          .catch(() => {
            this.$toast.error(this.$t('Erro ao adicionar sub-setor'))
          })
          .finally(() => {
            this.loading = false
          })
      } else if (type === 'edit') {
        this.apiService
          .post('department/subdepartment/edit', payload)
          .then(() => {
            this.$toast.success(this.$t('Sub-setor atualizado com sucesso'))
            this.searchDepartment()
          })
          .catch(() => {
            this.$toast.error(this.$t('Erro ao atualizar sub-setor'))
          })
          .finally(() => {
            this.loading = false
          })
      } else if (type === 'remove') {
        this.apiService
          .delete(`department/subdepartment/delete/${payload}`)
          .then(() => {
            this.$toast.success(this.$t('Sub-setor removido com sucesso'))
            this.searchDepartment()
          })
          .catch(() => {
            this.$toast.error(this.$t('Erro ao remover sub-setor'))
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    editSubdepartment() {
      if (this.$refs.subdepForm.validate()) {
        this.editLoading = true
        this.handleSubdepAction({
          type: 'edit',
          payload: this.currentSubDepartment,
        })
        this.editSubdepartmentDialog = false
        this.editLoading = false
        this.searchDepartment()
      }
    },

    newSubDepartment(index) {
      const subDepartment = this.newDepartment.subDepartments[index]
      subDepartment.departmentId = this.newDepartment.id
      this.handleSubdepAction({ type: 'add', payload: subDepartment })
      this.newDepartment.subDepartments.pop()
    },

    sendSubdepartment(index) {
      const subDepartment = this.currentDepartment.subDepartments[index]
      subDepartment.departmentId = this.currentDepartment.id

      if (!subDepartment.name) {
        this.$toast.warning('Insira o nome do setor')
        return
      }

      this.handleSubdepAction({ type: 'add', payload: subDepartment })
      this.currentDepartment.subDepartments.pop()
    },

    addSubDepartment(i) {
      this.currentDepartment = this.departments[i]
      this.currentDepartment.subDepartments.push({
        name: '',
      })
    },

    removeNewSubDepartment(index) {
      const subDepartment = this.newDepartment.subDepartments[index]

      if (subDepartment.id) {
        this.handleSubdepAction({ type: 'remove', payload: subDepartment.id })
        this.newDepartment.subDepartments.splice(index, 1)
      } else {
        this.newDepartment.subDepartments.splice(index, 1)
      }
    },

    addNewSubDepartment() {
      const notAdded = this.newDepartment.subDepartments.find((x) => !x.id)

      if (notAdded) {
        this.$toast.warning('Atenção! Adicione um sub-setor por vez!')
        return
      }

      this.newDepartment.subDepartments.push({
        name: '',
      })
    },

    removeSubDepartment(index, i) {
      this.currentDepartment = this.departments[i]
      if (this.currentDepartment.subDepartments[index].name == '') {
        this.currentDepartment.subDepartments.splice(index, 1)
        return
      }

      const subDepartment = this.currentDepartment.subDepartments[index]
      this.isEditing = true

      if (subDepartment.id) {
        this.handleSubdepAction({ type: 'remove', payload: subDepartment.id })
        this.currentDepartment.subDepartments.splice(index, 1)
      } else {
        this.currentDepartment.subDepartments.splice(index, 1)
      }
    },

    async getUnidades() {
      let url = 'unidade/list'

      if (this.institutionId) {
        url = `unidade/list/${this.institutionId}`
      }

      await this.apiService.get(url).then((response) => {
        this.unidades = response.content
      })
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.alterDialog = false
      this.close()
    },

    callConfirmDialog() {
      if (this.isEditing && this.$refs.firstForm.validate()) {
        this.confirmDialog = true
      } else {
        this.submit()
      }
    },

    async importExcelFile() {
      var reader = new FileReader()
      reader.readAsDataURL(this.file)
      reader.onload = () => {
        this.data = reader.result
        const fileModel = {
          File: this.data,
          InstitutionId: this.institutionId,
        }

        this.apiService.post('department/import', fileModel).then(() => {})
      }
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },

    deleteDepartment(i) {
      this.deletedDepartment = this.departments[i]

      this.deleteDialog = true
    },

    activeDepartment(i) {
      try {
        this.isEditing = true
        this.currentDepartment = this.departments[i]
        this.currentDepartment.status = 0
        this.submit()
      } catch (er) {
        console.error(er)
      }
    },

    filterDepartment() {
      this.page = 1
      this.searchDepartment()
    },

    async searchDepartment() {
      this.departmentLoading = true
      const filter = {
        institutionId: this.institutionId,
        unityId: this.unidadeId,
        departmentName: this.departmentName,
        page: this.page,
        pageSize: this.pageSize,
      }
      if (this.active) {
        await this.apiService
          .post(`department/listActiveFiltered`, filter)
          .then((response) => {
            this.departments =
              response.content.data ??
              response.content.departments ??
              response.content
            this.totalPages = response.content.pager?.totalPages ?? 1
            this.totalItems =
              response.content.pager?.totalItems ??
              (
                response.content.data ??
                response.content.departments ??
                response.content
              ).length
            this.departmentLoading = false
          })
      } else {
        await this.apiService
          .post(`department/listInactiveFiltered`, filter)
          .then((response) => {
            this.departments =
              response.content.data ??
              response.content.departments ??
              response.content
            this.totalPages = response.content.pager?.totalPages ?? 1
            this.totalItems =
              response.content.pager?.totalItems ??
              (
                response.content.data ??
                response.content.departments ??
                response.content
              ).length
            this.departmentLoading = false
          })
      }
    },

    async searchDepartmentExcel() {
      this.departmentLoading = true
      const filter = {
        institutionId: this.institutionId,
        unityId: this.unidadeId,
        departmentName: this.departmentName,
      }
      if (this.active) {
        await this.apiService
          .post(`department/listActiveFiltered/Excel`, filter)
          .then((response) => {
            var excelResult = `data:application/octet-stream;base64,${response.content}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', 'setores.xlsx')
            document.body.appendChild(link)
            link.click()
            this.departmentLoading = false
          })
      } else {
        await this.apiService
          .post(`department/listInactiveFiltered/Excel`, filter)
          .then((response) => {
            var excelResult = `data:application/octet-stream;base64,${response.content}`
            const link = document.createElement('a')
            link.href = excelResult
            link.setAttribute('download', 'setores.xlsx')
            document.body.appendChild(link)
            link.click()
            this.departmentLoading = false
          })
      }
    },

    selectedDepartment() {
      const department = this.departments.find(
        (department) => department.id === this.departmentId
      )

      if (department.id > 0) {
        this.isEditing = true
        this.currentDepartment = department
        this.status = department.status == 0
        this.applyRules = true
      } else {
        this.currentDepartment = {
          subDepartments: [],
        }
        this.isEditing = false
      }
    },

    async addDepartment() {
      if (!this.$refs.addForm.validate()) {
        return
      }
      this.currentDepartment = {
        id: this.newDepartment.id,
        institutionId: this.institutionId,
        unidadeId: this.newDepartment.unidadeId,
        name: this.newDepartment.name,
        initials: this.newDepartment.initials,
        subDepartments: this.newDepartment.subDepartments,
        status: this.newDepartment.status,
        opexBudgets: this.buildOpexBudgets(),
      }
      await this.submit()
    },

    buildOpexBudgets() {
      if (
        this.newDepartment.plannedOpex === null ||
        this.newDepartment.plannedOpex === '' ||
        Number(this.newDepartment.plannedOpex) === 0
      ) {
        return []
      }

      return [
        {
          year: this.opexYear,
          plannedOpex: Number(this.newDepartment.plannedOpex),
        },
      ]
    },

    setInitialDepertment() {
      this.applyRules = false
      this.departmentId = 0
      this.currentDepartment = null
    },

    async submit() {
      this.loading = true
      this.confirmDialog = false

      let url = 'department/add'

      if (this.isEditing) {
        url = 'department/edit'

        const notAdded = this.newDepartment.subDepartments.find((x) => !x.id)

        if (notAdded) {
          this.$toast.warning(
            'Parece que há um sub-setor com inserção pendente na sua lista de sub-setores, adicione-o para prosseguir'
          )
          return
        }
      }

      await this.apiService
        .post(url, this.currentDepartment)
        .then((response) => {
          url == 'department/edit'
            ? this.$toast.success('Setor atualizado com sucesso!')
            : this.$toast.success('Novo setor criado! 🏢')
          this.loading = false
          this.setInitialDepertment()
          this.searchDepartment()
          this.showSuccessAlert(response.message)
          this.currentDepartment = null
          this.loading = false
          this.isEditing = false
          this.applyRules = true
          this.addDialog = false
          this.currentDepartment = null
          this.newDepartment = {
            Name: null,
            initials: null,
            unidadeId: null,
            subDepartments: [],
          }
        })
        .catch(() => {})
    },

    async remove() {
      this.deleteLoading = true
      const payload = {
        departmentId: this.deletedDepartment.id,
        userId: this.userId,
      }
      await this.apiService
        .delete('department/delete', payload)
        .then((response) => {
          this.setInitialDepertment()
          this.searchDepartment()
          this.showSuccessAlert(response.message)
          this.deleteDialog = false
          this.deleteLoading = false
        })
        .catch((error) => {
          this.deleteLoading = false
          this.deleteDialog = false
        })
      this.isEditing = false
      this.applyRules = true
    },
  },

  watch: {
    page() {
      this.searchDepartment()
    },

    pageSize() {
      this.page = 1
      this.searchDepartment()
    },

    currentDepartment: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
